import { observable, computed } from 'mobx'
import moment from 'moment'

//models
import Adventure from 'models/Adventure'
import Reserve from 'models/Reserve'

export const PUBLIC_REQUEST = 1;
export const PRIVATE_REQUEST = 2;

class Request {
  @observable pk_request
  @observable adventure
  @observable created_at
  @observable date
  @observable view_access
  @observable hour
  @observable is_deleted
  @observable payed
  @observable payedValue
  @observable person
  @observable recieved
  @observable reserves
  @observable short_url
  @observable status
  @observable to_recieve
  @observable type
  @observable fk_rule_time
  @observable fk_rule_time_operation
  @observable custom_fields
  @observable max
  @observable widget

  constructor(json = {}) {
    this.adventure = new Adventure(json.adventure || {})
    this.view_access = json.view_access
    this.pk_request = json.pk_request
    this.fk_adventure = json.fk_adventure
    this.created_at = json.created_at
    this.date = json.date
    this.hour = json.hour
    this.is_deleted = json.is_deleted
    this.payed = json.payed || 0
    this.payedValue = json.payedValue || 0
    this.person = json.person
    this.recieved = json.recieved
    this.reserves = Array.isArray(json.reserves) ? json.reserves.map(reserve => new Reserve(reserve)) : []
    this.name = json.name
    this.observation = json.observation
    this.email = json.email
    this.phone = json.phone
    this.short_url = json.short_url
    this.status = json.status
    this.to_recieve = json.to_recieve || 0
    this.type = json.type
    this.fk_rule_time = json.fk_rule_time
    this.fk_rule_time_operation = json.fk_rule_time_operation
    this.custom_fields = json.custom_fields || []
    this.max = json.max
    this.widget = json.widget
    this.user = json.user
    this.fk_user = json.fk_user

    this.tags = json.tags || []

  }

  @computed
  get day() {
    return moment(this.date)//.format('YYYY-MM-DD')
  }

  @computed
  get hasSomeObservationInfos() {
    return !!this.name || !!this.observation || !!this.email || !!this.phone
  }

  @computed
  get isUrgent() {
    return this.status === 0
  }

  @computed
  get isConfirmed() {
    return this.status === 1
  }

  @computed
  get isThisWeek() {
    const nextWeek = moment().add(7, 'day')
    return moment(this.date).isBefore(nextWeek) && moment(this.date).isAfter(moment().subtract('1', 'day'))
  }

  @computed
  get created_by() {
    if (this.widget) return 'pelo widget';
    else if (this.fk_user === 1) return 'por você';

    return !!this.user ? `por ${this.user.name}` : ''
  }

  @computed
  get hasBoleto() {

    //console.log(!!this.reserves.find((r) => r.payment.method === "BOLETO"))
    
    if(this.reserves) {
      return !!this.reserves.find((r) => r.payment.method === "BOLETO")
    } else {
      return false
    }
    
  }
}

export default Request


// WEBPACK FOOTER //
// ./src/models/Request.js